import React from 'react';
import styles from './TagList.module.css';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

type TagListProps = {
  list: string[],
  max: number,
}

export const TagList: React.FC<TagListProps> = React.memo(({list, max = 6}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tagListRoot}>
      { list.slice(0, max).map((l, i) => <div key={`tag-list-${i}`} className={styles.tagListElement}>{l}</div>) }
      { list.length > max && <div className={classnames(styles.tagListElement, styles.tagListMore)}>{t('set-thresholds-location-info-more', { count: list.length - max })}</div> }
    </div>
  )
})
